import styled from "styled-components";

export const OutletDefault = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px;
  width: 100%;
  height: 100%;
`;
